const colors = {
    darkGray: "#404041",
    gray: "#D9D9D9",
    lightestGray: "#FAFAFA",
    lightGray: "#F4F4F7",
    mediumGray: "#EBEBEB",
    mediumGrayDark: "#E0E0E0",
    mediumDarkestGray: "#C9C9C9",
    mediumDarkGray: "rgb(183, 183, 183, .16)",
    orange: "#FF6310",
    orangeDark: "#DE550A",
    orangeDark10: "rgba(255, 99, 16, .1)",
    orangeDark20: "rgba(255, 99, 16, .2)",
    white: "#FFF",
    blue: "#272763",
    darkRed: "#E54F54"
};

const borderRadius = {
    sm: "4px",
    smd: "6px",
    md: "10px"
};

const fontSize = {
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    code: "88%"
};

const fontFamily = {
    code: 'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace'
}

const fontWeight = {
    regular: "400",
    semibold: "600",
    bold: "bold"
};

const boxShadow = {
    default: "3px 3px 10px rgba(0, 0, 0, 0.15)",
    modal: "0 3px 6px -1px rgb(0,0,0,0.5)"
};

export const styledComponentTheme = {
    borderRadius,
    colors,
    fontSize,
    fontFamily,
    fontWeight,
    boxShadow
};

export const antDesignTheme = {
    token: {
        colorLink: colors.orange,
        colorPrimary: colors.orange,
        fontFamily: 'Source Sans Pro, sans-serif',
        colorSplit: colors.mediumDarkestGray,
        colorBgContainerDisabled: colors.mediumDarkestGray
    },
    components: {
        Breadcrumb: {
            itemColor: colors.darkGray,
            lastItemColor: colors.darkGray,
            linkColor: colors.orange,
            separatorColor: colors.darkGray
        },
        Button: {
            fontWeight: 'bold',
            colorText: colors.orange,
            borderRadius: 15,
        },
        Card: {
            actionsBg: colors.lightestGray,
            actionsLiMargin: "4px",
            colorTextHeading: colors.darkGray,
            colorBgContainer: colors.lightestGray,
            headerBg: colors.mediumDarkGray,
            headerHeight: 46
        },
        Input: {
            colorBorder: colors.mediumDarkestGray,
            colorText: colors.darkGray
        },
        Pagination: {
            itemActiveBg: colors.orange
        },
        Select: {
            colorBorder: colors.mediumDarkestGray,
            optionActiveBg: colors.orangeDark10,
            optionSelectedBg: colors.orangeDark20
        },
        Table: {
            borderColor: "#E0E0E0",
            cellPaddingBlock: 12,
            headerBg: "rgba(183, 183, 183, 0.16)",
            headerColor: colors.darkGray
        },
        Tag: {
            defaultBg: "transparent",
            defaultColor: colors.darkGray,
        }
    }
};
